export type AvailabilityStatusKeys = {
  dateRangeText: string;
  dateText: string;
  weeklyScheduleText: string;
};

export type AvailabilityStatusKeysConfig = {
  hasNextAvailabilityKeys: AvailabilityStatusKeys;
  noNextAvailabilityKeys: AvailabilityStatusKeys;
};

export type AvailabilityStatusKeysStructure = {
  menu: AvailabilityStatusKeysConfig;
  section: AvailabilityStatusKeysConfig;
  itemModal: AvailabilityStatusKeysConfig;
};

export const availabilityStatusKeys = {
  menu: {
    hasNextAvailabilityKeys: {
      dateRangeText: 'menu_olo.menuAvailabilityStatus.dateRange.text',
      dateText: 'menu_olo.menuAvailabilityStatus.oneDate.text',
      weeklyScheduleText: 'menu_olo.menuAvailabilityStatus.weeklySchedule.text',
    },
    noNextAvailabilityKeys: {
      dateRangeText: 'menu_olo.menuAvailabilityStatus.dateRange.noNextAvailability.text',
      dateText: 'menu_olo.menuAvailabilityStatus.oneDate.noNextAvailability.text',
      weeklyScheduleText: 'menu_olo.menuAvailabilityStatus.weeklySchedule.noNextAvailability.text',
    },
  },
  section: {
    hasNextAvailabilityKeys: {
      dateRangeText: 'section.sectionAvailabilityStatus.dateRange.text',
      dateText: 'section.sectionAvailabilityStatus.oneDate.text',
      weeklyScheduleText: 'section.sectionAvailabilityStatus.weeklySchedule.text',
    },
    noNextAvailabilityKeys: {
      dateRangeText: 'section.sectionAvailabilityStatus.dateRange.noNextAvailability.text',
      dateText: 'section.sectionAvailabilityStatus.oneDate.noNextAvailability.text',
      weeklyScheduleText:
        'section.sectionAvailabilityStatus.weeklySchedule.noNextAvailability.text',
    },
  },
  itemModal: {
    hasNextAvailabilityKeys: {
      dateRangeText: 'itemModal.menuAvailabilityStatus.dateRange.canUpdateTime.text',
      dateText: 'itemModal.menuAvailabilityStatus.oneDate.canUpdateTime.text',
      weeklyScheduleText: 'itemModal.menuAvailabilityStatus.weeklySchedule.canUpdateTime.text',
    },
    noNextAvailabilityKeys: {
      dateRangeText: 'itemModal.menuAvailabilityStatus.dateRange.noNextAvailability.text',
      dateText: 'itemModal.menuAvailabilityStatus.oneDate.noNextAvailability.text',
      weeklyScheduleText: 'itemModal.menuAvailabilityStatus.weeklySchedule.noNextAvailability.text',
    },
  },
};
